import styled from "styled-components";
import { QUERIES, SPACING } from "../../../../../utils/constants";

// Mobile/tablet: two stacked cards; laptop and up: one banner split by a vertical rule.

export const HeroLayout = styled.div<{ $single: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.md}px;
  font-family: "Crimson Pro", sans-serif;

  @media ${QUERIES.tabletLargeAndUp} {
    gap: ${SPACING.lg}px;
  }

  @media ${QUERIES.laptopAndUp} {
    display: grid;
    grid-template-columns: ${({ $single }) => ($single ? "1fr" : "1.6fr 1fr")};
    gap: 0;
    align-items: stretch;
    background: var(--hero-background);
    border: 1px solid var(--color-card-border);
    border-radius: 16px;
    box-shadow: var(--shadow-small);
    overflow: hidden;
  }
`;
